module.exports = __webpack_public_path__ + "static/media/Tennis.fea7db0d.webp";